import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useCustomers, useUpdateProject } from '../api/queries'
import type { Project } from '../api/types'

/**
 * Sagens kunde - og et skift af den (beslutning 084).
 *
 * Til en sag, der er oprettet på den forkerte kunde. Kan rettes af Superadmin,
 * Administrator og Projektleder. Er det en servicesag med enheder, afviser serveren
 * skiftet og siger hvorfor: enhederne står hos den nuværende kunde (beslutning 076).
 */
export function CustomerControl({ project, canEdit }: { project: Project; canEdit: boolean }) {
  const update = useUpdateProject(project.id)
  const [editing, setEditing] = useState(false)
  // Kun aktive kunder: en inaktiv kunde skal ikke få nye sager flyttet over.
  const { data: customers } = useCustomers()
  const [value, setValue] = useState('')
  const [error, setError] = useState<string | null>(null)

  function start() {
    setValue(project.customerId ? String(project.customerId) : '0')
    setError(null)
    setEditing(true)
  }

  async function save(event: React.FormEvent) {
    event.preventDefault()
    setError(null)

    try {
      // 0 = ingen kunde. Serveren læser null som "lad stå".
      await update.mutateAsync({ customerId: Number(value) })
      setEditing(false)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Kunden kunne ikke skiftes.')
    }
  }

  if (editing) {
    return (
      <form className="row" style={{ gap: 6, flexWrap: 'wrap', marginTop: 4 }} onSubmit={(e) => void save(e)}>
        <select
          aria-label="Kunde"
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          style={{ width: 'auto', maxWidth: 260 }}
        >
          <option value="0">Ingen kunde</option>
          {customers?.map((customer) => (
            <option key={customer.id} value={customer.id}>
              {customer.name}
              {customer.city ? ` (${customer.city})` : ''}
            </option>
          ))}
        </select>
        <button className="btn btn--primary btn--sm" type="submit" disabled={update.isPending}>
          {update.isPending ? 'Gemmer ...' : 'Gem'}
        </button>
        <button className="btn btn--sm" type="button" onClick={() => setEditing(false)}>
          Fortryd
        </button>
        {error && <span className="tiny warn">{error}</span>}
      </form>
    )
  }

  return (
    <span className="row" style={{ gap: 8, display: 'inline-flex', flexWrap: 'wrap' }}>
      {project.customerId ? <Link to={`/customers/${project.customerId}`}>{project.customer}</Link> : 'Ingen kunde'}
      {canEdit && (
        <button className="btn btn--sm" type="button" onClick={start}>
          Skift kunde
        </button>
      )}
    </span>
  )
}
